import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MainService } from 'BaseServices/main-service';
import { EquipmentServiceDetailDTO } from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';
import { dialogInputTitleComponent } from 'src/app/elements/dialog-input-title.component';
import { MatCheckbox } from '@angular/material/checkbox';

type ColorItem = { id: string; name: string };

@Component({
  selector: 'app-equipment-perform-control-tab',
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    dialogInputTitleComponent,
    MatCheckbox
  ],
  templateUrl: './equipment-perform-control-tab.component.html',
  styleUrl: './equipment-perform-control-tab.component.css',
})
export class EquipmentPerformControlTabComponent {
  equipmentId = 0;

  serviceColorItems: ColorItem[] = [
    { id: '#FF9900', name: 'Orange' },
    { id: '#FFFFFF', name: 'Hvid' },
    { id: '#FF0000', name: 'Rød' },
    { id: '#00FF00', name: 'Grøn' },
    { id: '#FFFF00', name: 'Gul' },
    { id: '#9900FF', name: 'Lilla' },
    { id: '#0000FF', name: 'Blå' },
    { id: '#00FFFF', name: 'Cyan' },
    { id: '#FF00FF', name: 'Magenta' },
  ];

  equipmentService: EquipmentServiceDetailDTO = {
    id: 0,
    equipmentId: 0,
    serviceBy: '',
    serviceDate: new Date(),
    serviceComment: '',
    serviceColor: '',
    typeService: false,
    typeCalibration: false,
    typeRepair: false,
    typeMalfunction: false,
    typeVerification: false,
  };

  constructor(
    private mainService: MainService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.activatedRoute.parent?.paramMap.subscribe((params) => {
      this.equipmentId = Number(params.get('id') ?? 1490);
      this.equipmentService.equipmentId = this.equipmentId;

      console.log('equipmentId:', this.equipmentId);
    });
  }

  get controlTypeText(): string {
    const types: string[] = [];

    if (this.equipmentService.typeService) types.push('Service');
    if (this.equipmentService.typeCalibration) types.push('Kalibrering');
    if (this.equipmentService.typeRepair) types.push('Reparation');
    if (this.equipmentService.typeVerification) types.push('Verifikation');
    if (this.equipmentService.typeMalfunction) types.push('Defekt');

    return types.length ? types.join(', ') : '';
  }

  get isServiceSaveDisabled(): boolean {
    const hasType =
      !!this.equipmentService.typeService ||
      !!this.equipmentService.typeCalibration ||
      !!this.equipmentService.typeRepair ||
      !!this.equipmentService.typeVerification ||
      !!this.equipmentService.typeMalfunction;

    return (
      !this.equipmentId ||
      !this.equipmentService.serviceBy ||
      this.equipmentService.serviceBy.trim().length === 0 ||
      !(this.equipmentService.serviceDate instanceof Date) ||
      !hasType
    );
  }

  saveService(): void {
    if (!this.equipmentId || this.equipmentId <= 0) {
      Swal.fire({
        title: 'Fejl',
        text: 'Kunne ikke finde et gyldigt equipment id i URLen.',
        icon: 'error',
        confirmButtonText: 'Ok',
      });
      return;
    }

    if (this.isServiceSaveDisabled) return;

    const payload: any = {
      EquipmentId: this.equipmentId,
      ServiceDate: this.equipmentService.serviceDate,
      ServiceBy: (this.equipmentService.serviceBy ?? '').trim(),
      ServiceComment: (this.equipmentService.serviceComment ?? '').trim(),
      ServiceColor: this.equipmentService.serviceColor ?? null,
      TypeService: !!this.equipmentService.typeService,
      TypeCalibration: !!this.equipmentService.typeCalibration,
      TypeRepair: !!this.equipmentService.typeRepair,
      TypeVerification: !!this.equipmentService.typeVerification,
      TypeMalfunction: !!this.equipmentService.typeMalfunction,
    };

    console.log('Service payload:', payload);

    this.mainService.add<any, any>('EquipmentService', payload).subscribe({
      next: () => {
        Swal.fire({
          title: 'Gemt',
          text: 'Kontrol er gemt.',
          icon: 'success',
          confirmButtonText: 'Ok',
        }).then(() => {
          this.router.navigate(['/søgudstyr']);
        });
      },
      error: (err) => {
        console.error('Service save error:', err);
        Swal.fire({
          title: 'Fejl',
          text: 'Kunne ikke gemme kontrol.',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      },
    });
  }
}
